export const toastContainer: CSSFunction = () => ({
  position: 'fixed',
  top: '20px',
  right: '30px',
  width: '100%',
  maxWidth: '328px',
  zIndex: 1000,
});
